import { render, staticRenderFns } from "./MasterGoals.vue?vue&type=template&id=2c43666c&"
import script from "./MasterGoals.vue?vue&type=script&lang=js&"
export * from "./MasterGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports